import type { ToolFaq } from "./tool-faqs/soil-temperature"

export const homepageFaqs: ToolFaq[] = [
  {
    question: "How do I identify my grass type from a photo?",
    answer:
      "Take a daylight close-up of your grass blades and upload it here. Our AI grass identifier returns the most likely species, a confidence score, and a starter care plan in about 15 seconds. There's no signup needed to try it.",
  },
  {
    question: "Is there a free grass identifier I can use by picture?",
    answer:
      "Yes. This is a free grass identifier that works from a single picture, right in your browser. Snap a close-up of your lawn, upload it, and you'll get your grass type plus a 12-month care plan tuned to your zip, without installing anything.",
  },
  {
    question: "Is this really free?",
    answer:
      "Yes. Identifying your grass and getting a year-round care plan is free, and you don't need to create an account to run an analysis. We support the site through affiliate links on product recommendations and a small premium tier for unlimited monthly analyses.",
  },
  {
    question: "How accurate is the AI?",
    answer:
      "Every result includes a confidence score so you know how sure the model is. For clear daylight close-ups it's highly reliable on the common North American grasses we cover. If the model is uncertain it tells you so and offers the most likely alternatives instead of guessing.",
  },
  {
    question: "What grass types does it cover?",
    answer:
      "The warm-season and cool-season grasses you'll find on most North American residential lawns: bermudagrass, zoysia, St. Augustine, centipede, bahiagrass, buffalograss, Kentucky bluegrass, tall fescue, fine fescue, and perennial ryegrass. Mixed lawns are common, so the model flags the dominant species plus likely co-occupants.",
  },
  {
    question: "What if my photo isn't great?",
    answer:
      "Aim for a daylight close-up of the grass blades, not a wide shot of the whole lawn. Too far back, blurry, or shadowed photos return a low confidence score with a suggestion to retake. You can upload a different photo at any time without using up your free analysis.",
  },
  {
    question: "Will you sell my email or location data?",
    answer:
      "No. Your zip is used to tune your care plan and your email is only used to send you the plan and any reminders you opt into. One-click unsubscribe, and we don't sell your data.",
  },
]
